var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.formSubmitted)?_c('input',{class:_vm.buttonclass,attrs:{"type":"submit"},domProps:{"value":_vm.title},on:{"click":_vm.checkForm}}):_c('input',{class:_vm.processingclass,attrs:{"type":"submit"},domProps:{"value":_vm.title},on:{"click":_vm.pauseForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }